module.exports = __webpack_public_path__ + "img/periodSelect.85d01026.jpg";